const TenantBadge = ({ tenant }) => {
  if (!tenant) return null;

  return (
    <span className="tenant-badge badge bg-light text-dark border ms-2 text-wrap" title={tenant.domain || tenant.name}>
      <span className="tenant-badge__label">Workspace</span>
      <strong>{tenant.name || tenant.domain || "Tenant"}</strong>
    </span>
  );
};

export default TenantBadge;